import { render, staticRenderFns } from "./Program_Del.vue?vue&type=template&id=0619d992&"
import script from "./Program_Del.vue?vue&type=script&lang=js&"
export * from "./Program_Del.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports